import React from 'react';
import { Link } from 'react-router-dom';
import './About.css';

const History = () => {
  const historyTimeline = [
    {
      year: '2009',
      title: 'The Foundation',
      description: 'Net Nest Badminton Sports Club was established in 2009 with a simple yet powerful vision—to create a dedicated space for badminton training and encourage young players to take up the sport seriously. The early days focused on basic coaching, discipline, and introducing structured practice sessions for local players.',
      image: 'https://images.unsplash.com/photo-1599474924187-334a4ae5bd3c?w=400'
    },
    {
      year: '2012',
      title: 'Building the Basics',
      description: 'During this phase, the club concentrated on strengthening its foundation: Introduction of regular training batches Focus on fundamentals such as footwork, grip, and stroke techniques Growing interest among students and amateur players These years helped establish Net Nest as a trusted local badminton training center.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    },
    {
      year: '2015',
      title: 'Growing Recognition',
      description: 'As player participation increased, Net Nest began gaining recognition for its disciplined training approach. The club: Expanded training schedules Started preparing players for local and inter-school tournaments Emphasized fitness and match practice Several players began showcasing improved performance, marking the club’s first competitive successes.',
      image: 'https://images.unsplash.com/photo-1613918431703-aa50889e3be6?w=400'
    },
    {
      year: '2018',
      title: 'Structured Development',
      description: 'This period marked a significant shift toward professional training standards. Net Nest: Introduced age- wise and skill - level training programs Focused on competitive mindset and match strategies Encouraged participation in district - level tournaments The club started shaping players with long - term development goals rather than short - term results.',
      image: 'https://images.unsplash.com/photo-1599474924187-334a4ae5bd3c?w=400'
    },
    {
      year: '2019',
      title: 'Strengthening Competitive Focus',
      description: 'By 2019, Net Nest Badminton Sports Club had built a strong reputation for quality coaching. Key developments included: Advanced training modules for serious players Greater emphasis on physical conditioning and endurance Increased tournament exposure This year reflected the club’s growing ambition to develop high-performing athletes.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    },
    {
      year: '2020',
      title: 'Overcoming Challenges',
      description: 'The year 2020 brought unexpected challenges, but Net Nest remained committed to its players. The club focused on: Skill refinement and fitness guidance Maintaining player engagement and motivation Preparing for a stronger comeback This phase reinforced the club’s resilience and dedication to the sport.',
      image: 'https://images.unsplash.com/photo-1613918431703-aa50889e3be6?w=400'
    },
    {
      year: '2021',
      title: 'Restart and Renewal',
      description: 'With renewed energy, Net Nest resumed full-scale training: Refined coaching methods Renewed focus on fitness and injury prevention Encouraged players to regain competitive rhythm The club emerged stronger and more focused on long- term excellence.',
      image: 'https://images.unsplash.com/photo-1599474924187-334a4ae5bd3c?w=400'
    },
    {
      year: '2022',
      title: 'Expansion of Training Vision',
      description: 'WIn 2022, Net Nest took important steps toward broader development: Enhanced training structure Focus on youth development programs Promotion of discipline, consistency, and sports ethics The club welcomed more young aspirants and beginners eager to learn badminton professionally.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    },
    {
      year: '2023',
      title: 'Performance & Progress',
      description: 'This year highlighted steady progress: Improved tournament performances Stronger player confidence and match temperament Increased emphasis on advanced techniques and strategies Net Nest continued to evolve as a performance-driven badminton club.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    },
    {
      year: '2024',
      title: 'Strengthening the Foundation',
      description: 'In 2024, the club focused on strengthening its core values: Player-centric coaching approach Balanced focus on skill, fitness, and mental strength Community building among players and families This year reinforced Net Nest’s identity as a disciplined and supportive sports environment.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    },
    {
      year: '2025',
      title: 'Preparing Future Champions',
      description: 'By 2025, Net Nest Badminton Sports Club emphasized future readiness: Competitive training for advanced players Grooming young talent for higher-level tournaments Continuous improvement in coaching standards The club positioned itself as a platform for aspiring competitive athletes.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    },
    {
      year: '2026',
      title: 'A Legacy in the Making',
      description: 'As of 2026, Net Nest Badminton Sports Club stands as a symbol of dedication, growth, and sporting excellence. With years of experience, a strong training culture, and a clear vision for the future, the club continues to inspire players to dream big and work hard. From humble beginnings in 2009 to a recognized badminton training institution in 2026, Net Nest’s journey reflects its unwavering commitment to building skilled players, confident individuals, and a lasting badminton legacy.',
      image: 'https://images.unsplash.com/photo-1626224583764-f87db24ac4ea?w=400'
    }
  ];

  return (
    <div className="history-page">
      {/* Page Header */}
      <section className="page-header">
        <div className="page-header-overlay"></div>
        <div className="container">
          <div className="page-header-content">
            <span className="page-badge">Our Journey</span>
            <h1>Our History</h1>
            <p>From humble beginnings to a premier badminton destination</p>
            <nav className="breadcrumb">
              <Link to="/">Home</Link>
              <span>/</span>
              <Link to="/about">About</Link>
              <span>/</span>
              <span>History</span>
            </nav>
          </div>
        </div>
      </section>

      {/* History Intro */}
      <section className="section">
        <div className="container">
          <div className="history-intro">
            <div className="section-header center">
              <span className="section-badge">Since 2009</span>
              <h2>15 Years of Badminton Excellence</h2>
              <p>
                What started as a dream shared by two badminton enthusiasts has grown into
                one of the region's most respected sports facilities. Our journey is a
                testament to the power of passion, community, and dedication to excellence.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Detailed Timeline */}
      <section className="history-timeline section">
        <div className="container">
          {historyTimeline.map((item, index) => (
            <div className={`history-item ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
              <div className="history-content">
                <span className="history-year">{item.year}</span>
                <h3>{item.title}</h3>
                <p>{item.description}</p>
              </div>
              <div className="history-image">
                <img src={item.image} alt={item.title} />
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Be Part of Our Story</h2>
            <p>Join the Net Nest family and write the next chapter with us</p>
            <div className="cta-buttons">
              <Link to="/membership" className="btn btn-white">Become a Member</Link>
              <Link to="/contact" className="btn btn-outline-white">Contact Us</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default History;
